export const states = () => {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj ? JSON.parse(userObj) : {};
  const state = userDetail?.config?.filters?.filter(
    (item: any) => item?.type === "state"
  );
  if (Array.isArray(state) && state.length !== 0) {
    const _state = state[0].values.map((item: any) => {
      return {
        name: item.value,
        code: item.value
      };
    });
    return _state;
  }
  return [];
};

export const sortByOptions = [
  { name: "Newest", code: "newest" },
  { name: "Oldest", code: "oldest" }
];

export const prices = [
  { name: "10,000 - 20,000", code: "1" },
  { name: "20,000 - 30,000", code: "2" },
  { name: "30,000 - 40,000", code: "3" },
  { name: "40,000 - 50,000", code: "4" },
  { name: "50,000 - 60,000", code: "5" }
];

export const occupancy = () => {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj ? JSON.parse(userObj) : {};
  const _occupancy = userDetail?.config?.filters?.filter(
    (item: any) => item?.type === "occupancy"
  );
  if (Array.isArray(_occupancy) && _occupancy.length !== 0) {
    const occupancy = _occupancy[0]?.values?.map((item: any) => {
      return {
        name: item?.value,
        code: item?.value.toLowerCase()
      };
    });
    return occupancy;
  }
  return [];
};

export const offMarket = () => {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj ? JSON.parse(userObj) : {};
  const off_market = userDetail?.config?.filters?.filter(
    (item: any) => item?.type === "off_market"
  );
  if (Array.isArray(off_market) && off_market.length !== 0) {
    const offMarket = off_market[0]?.values?.map((item: any) => {
      return {
        name: item?.value,
        code: item?.value
      };
    });
    return offMarket;
  }
  return [];
};

export const salesInstructions = () => {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj ? JSON.parse(userObj) : {};
  const sales_instruction = userDetail?.config?.filters?.filter(
    (item: any) => item?.type === "sales_instruction"
  );
  if (Array.isArray(sales_instruction) && sales_instruction?.length !== 0) {
    const salesInstruction = sales_instruction[0]?.values?.map((item: any) => {
      return {
        name: item?.value,
        code: item?.value.toLowerCase()
      };
    });
    return salesInstruction;
  }
  return [];
};

export const statusOption = () => {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj ? JSON.parse(userObj) : {};
  const status_option = userDetail?.config?.filters?.filter(
    (item: any) => item?.type === "property_status"
  );
  if (Array.isArray(status_option) && status_option?.length !== 0) {
    const statusOption = status_option[0]?.values?.map((item: any) => {
      return {
        name: item?.value,
        code: item?.value.toLowerCase()
      };
    });
    return statusOption;
  }
  return [];
};

export const PossessionDelivery = () => {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj ? JSON.parse(userObj) : {};
  const Possession_delivery = userDetail?.config?.filters?.filter(
    (item: any) => item?.type === "possession_delivery"
  );
  if (Array.isArray(Possession_delivery) && Possession_delivery?.length !== 0) {
    const PossessionDelivery = Possession_delivery[0]?.values?.map(
      (item: any) => {
        return {
          name: item?.value,
          code: item?.value.toLowerCase()
        };
      }
    );
    return PossessionDelivery;
  }
  return [];
};
